import { ProductsId, SearchMaskMountOptions } from '@webc/meeseeks-ui-sdk';
import { getQueryString, getSearchMaskValuesFromQueryString } from 'app/functions';

import { isUuid } from 'app/functions/general/isUuid';
import { StoreTranslationsDateField } from 'app/models/types/store/translations';
import { fetchDatesTranslations, fetchTranslations } from 'app/providers';
import {
  loadUi,
  requestTranslationsSucceeded,
  UPDATE_OPTIONS,
  UpdateOptionsAction,
  requestUpdateLocation,
  setDepartureDate,
  setReturnDate,
  setProductQuantity,
} from 'app/store/actions';
import { featureStationSuggestionSelector, optionsSelector } from 'app/store/selectors';
import { takeLatest, select, put, call, all } from 'redux-saga/effects';

export function* requestTranslations(locale: string) {
  try {
    const [translationsResponse, translationsDatesResponse]: [
      { [key: string]: string },
      StoreTranslationsDateField,
    ] = yield all([call(fetchTranslations, locale), call(fetchDatesTranslations, locale)]);

    yield put(requestTranslationsSucceeded(translationsResponse, translationsDatesResponse));
  } catch (error) {
    // @todo: handle error
  }
}

export function* onUpdateOptions() {
  yield takeLatest<UpdateOptionsAction>(UPDATE_OPTIONS, function* (action: UpdateOptionsAction) {
    const oldOptions: ReturnType<typeof optionsSelector> = yield select(optionsSelector);
    const showStationSuggestions: boolean = yield select(featureStationSuggestionSelector);
    const newOptions: SearchMaskMountOptions = { ...oldOptions, ...action.options };
    const locale = newOptions.locale;
    const searchMaskValues = {
      ...action.options.initialSearchMaskValues,
      ...getSearchMaskValuesFromQueryString(getQueryString()),
    };
    const departureId = searchMaskValues.departureCity;
    const arrivalId = searchMaskValues.arrivalCity;
    if (departureId) {
      const key = isUuid(departureId) ? 'uuid' : 'legacyId';
      yield put(
        requestUpdateLocation('from', {
          [key]: departureId,
          ...(showStationSuggestions
            ? {
                stationId: searchMaskValues?.departureStop,
                stationName: searchMaskValues?.departureStopName,
              }
            : null),
        } as { uuid: string } | { stationId: string } | { legacyId: number }),
      );
    }
    if (arrivalId) {
      const key = isUuid(arrivalId) ? 'uuid' : 'legacyId';
      yield put(
        requestUpdateLocation('to', {
          [key]: arrivalId,
          ...(showStationSuggestions
            ? {
                stationId: searchMaskValues?.arrivalStop,
                stationName: searchMaskValues?.arrivalStopName,
              }
            : null),
        } as { uuid: string } | { stationId: string } | { legacyId: number }),
      );
    }

    if (searchMaskValues.departureDate) {
      yield put(setDepartureDate(Number(searchMaskValues.departureDate)));
    }
    if (searchMaskValues.returnDate) {
      yield put(setReturnDate(Number(searchMaskValues.returnDate)));
    }
    if (searchMaskValues.products) {
      const products = Object.keys(searchMaskValues.products) as ProductsId[];
      for (let i = 0; i < products.length; i++) {
        const amount = searchMaskValues.products[products[i]];
        if (typeof amount !== 'undefined') {
          yield put(setProductQuantity(products[i], amount));
        }
      }
    }
    yield all([requestTranslations(locale)]);

    yield put(loadUi());
  });
}
